export default __webpack_public_path__ + "static/media/big_head_-6.58a695f6.webp";